import React from "react";
import { Grid, Segment, Header, Label } from "semantic-ui-react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import PropTypes from "prop-types";

const labelContainerStyle = {
  paddingTop: "1em",
  display: "flex",
  flexWrap: "wrap",
  gap: "1em",
};

const keywords = [
  "dissolved organic carbon",
  "pH",
  "heavy metals (Pb, Cd)",
  "inorganic anions (SO₄²⁻, NO₃⁻, Cl⁻)",
  "soil water",
  "base cations (K, Na, Ca, Mg)",
  "lysimeter",
  "dissolved organic carbon",
  "pH",
  "heavy metals (Pb, Cd)",
];

const chartData = [
  { name: "Jan", value: 20 },
  { name: "Feb", value: 15 },
  { name: "Mar", value: 50 },
  { name: "Apr", value: 25 },
  { name: "May", value: 30 },
  { name: "Jun", value: 24 },
  { name: "Jul", value: 26 },
];

const KeywordLabels = ({ keywords }) => (
  <div style={labelContainerStyle}>
    {keywords.map((word) => (
      <Label key={word.key} color="blue" basic size="large">
        {word.label}
        <small> - ({word.doc_count})</small>
      </Label>
    ))}
  </div>
);

const AssetsUploadChart = ({ data }) => (
  <ResponsiveContainer width="100%" height={250}>
    <LineChart data={data} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="name" />
      <YAxis />
      <Tooltip />
      <Line
        type="monotone"
        dataKey="value"
        stroke="#007bff"
        strokeWidth={3}
        dot={{ r: 5 }}
        activeDot={{ r: 7 }}
      />
    </LineChart>
  </ResponsiveContainer>
);

const HomepageStatsDashboard = ({ commonKeywords }) => (
  <Grid stackable columns={2} doubling>
    <Grid.Column>
      <Segment
        padded
        style={{ height: "100%" }}
        className="homepage-stats-item"
      >
        <Header as="h3" style={{ marginBottom: "1.5em" }}>
          Most common used keywords
        </Header>
        <KeywordLabels keywords={commonKeywords} />
      </Segment>
    </Grid.Column>
    <Grid.Column>
      <Segment
        padded
        style={{ height: "100%" }}
        className="homepage-stats-item"
      >
        <Header as="h3" style={{ marginBottom: "1.5em" }}>
          Assets upload over time
        </Header>
        <AssetsUploadChart data={chartData} />
      </Segment>
    </Grid.Column>
  </Grid>
);

HomepageStatsDashboard.propTypes = {
  commonKeywords: PropTypes.array,
};

export default HomepageStatsDashboard;
